import { Injectable } from '@angular/core';
import { TokenService } from '@core/services/token/token.service';
import { environment } from '@environment';
import { UserService } from '@features/users/user.service';
import { BannerInfo } from '@yourcause/common';
import { I18nService } from '@yourcause/common/i18n';

@Injectable({ providedIn: 'root' })
export class ImpersonationBannerService {

  constructor (
    private userService: UserService,
    private i18n: I18nService,
    private tokenService: TokenService
  ) { }

  getImpersonationBanner (): BannerInfo {
    const user = this.userService.user;
    if (user && this.tokenService.hasImpersonationToken()) {
      const impersonatingText = this.i18n.translate(
        environment.isUat ?
          'common:textYouAreCurrentlyImpersonatingNameinUAT' :
          'common:textYouAreCurrentlyImpersonatingName',
        {
          name: user.firstName + ' ' + user.lastName
        },
        environment.isUat ?
          'You are currently impersonating __name__ in GrantsConnect UAT' :
          'You are currently impersonating __name__'
      ) + '.';
      const endSessionText = this.i18n.translate(
        'common:textEndSession',
        {},
        'End session'
      );

      return {
        visible: true,
        message: impersonatingText,
        buttonText: endSessionText,
        onButtonClick: this.tokenService.logout
      };

    }

    return null;
  }
}
